// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3SXhu","text":"SelectPayment_text__u6-xB","title":"SelectPayment_title__3aZ4x","btn":"SelectPayment_btn__1KnfK"};